import React, { useContext, useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { BackButton } from '../utils/Elements'
import InvoiceStatusHelper from '../helpers/InvoiceStatusHelper'
import InvoiceStatus from './InvoiceStatus'
import DirectDebitConsent from './DirectDebitConsent'
import DirectDebitConsentApi from '../services/api/DirectDebitConsent'
import LoadingComponent from './LoadingComponent'
import Context from '../context/Context'
import { ConsentStatuses } from '../helpers/Constants'
import PropTypes from 'prop-types'

const ConsentCreatedMessage = () => {
  return (
    <div className="row mt-2">
      <div className="col-12 text-center">
        <strong>Medgivande skapat.</strong>
        <p>När vill du betala?</p>
      </div>
    </div>
  )
}

const DirectPaymentOption = () => {
  const context = useContext(Context)

  return (
    <div className="row mt-2">
      <div className="col-12 text-center">
        <Link style={context.style.button}
          to={'/payment/oneclick/pay/1/sign' + context.url}
          className="btn btn-primary custom-btn-payment">Direkt</Link>
      </div>
    </div>
  )
}

const DueDatePaymentOption = () => {
  const context = useContext(Context)
  const dueDate = new Date(context.invoice.due_date)
  const today = new Date()

  if (dueDate > today) {
    return (
      <div className="row mt-2">
        <div className="col-12 text-center">
          <Link style={context.style.button}
            to={'/payment/oneclick/pay/2/sign' + context.url}
            className="btn btn-primary custom-btn-payment">På förfallodag</Link>
        </div>
      </div>
    )
  }

  return null
}

const OneClick = ({ isConsentCreated }) => {
  const context = useContext(Context)
  const [consents, setConsents] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(null)
  const responseStatus = useRef(0)

  useEffect(() => {
    const directDebitConsentApi = new DirectDebitConsentApi()
    directDebitConsentApi.get(context.invoice.ocr)
      .then(res => {
        responseStatus.current = res.status
        return res.json()
      })
      .then(data => {
        if (responseStatus.current === 200) {
          Object.entries(data).forEach(([key, value]) => {
            const consentStatus = parseInt(value.misc.consent_status_id)

            if ([ConsentStatuses.APPROVED, ConsentStatuses.REGISTERED].indexOf(consentStatus) !== -1) {
              setConsents(value)
            }
          })
        } else {
          setError(data.message)
        }

        setLoaded(true)
      })
      .catch(error => {
        setError(error.message)
      })

    return () => null
  }, [])

  const PayDateOptions = () => {
    return (
      <div>
        <div className="row mt-5">
          <div className="col-12 text-center">
            <h1>När vill du betala?</h1>
          </div>
        </div>
        <DirectPaymentOption />
        <DueDatePaymentOption />
      </div>
    )
  }

  if (error) {
    return (
      <div className="row mt-2">
        <div className="col-12 text-center">
          <p style={{ color: 'red' }}>{error}</p>
        </div>
      </div>
    )
  } else if (!loaded) {
    return <LoadingComponent />
  } else if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
    if (consents.length !== 0) {
      return (
        <div>
          {isConsentCreated ? <ConsentCreatedMessage /> : null}
          <PayDateOptions />
          <div className="row mt-2">
            <div className="col-12 text-center">
              <BackButton style={context.style} />
            </div>
          </div>
        </div>
      )
    } else {
      return <DirectDebitConsent />
    }
  } else {
    return <InvoiceStatus />
  }
}

OneClick.propTypes = {
  isConsentCreated: PropTypes.bool
}

export default OneClick
